import React from 'react';
import { bool } from 'prop-types';

const PreviousProductsDesktop = (props) => (
  <section
    className="gcc-prvprod cf relative mw9 center"
    style={{ minHeight: '355px' }}
    id="prev viewed product carousel"
  >
    <h2 className="f4 f3-ns w-100 tc mv4">Previously Viewed Products</h2>
    {!props.isLoading && (
      <div className="flex flex-column items-center w-100">
        <p className="b tc mt4">Looks like you don&apos;t have any previously viewed products.</p>
        <p className="mv2 tc">Why don&apos;t you checkout our latest sales?</p>
        <a className="gcc-btn gcc-btn-secondary mv3" href="/sale">
          View Our Latest Sales
        </a>
      </div>
    )}
  </section>
);

PreviousProductsDesktop.propTypes = {
  isLoading: bool.isRequired,
};

export default PreviousProductsDesktop;
